import React from 'react';
import { Link } from 'react-router-dom';
export function SummerCampPill() {
  return <Link to="/summer-camp" className="hidden lg:flex items-center gap-1.5 text-sm font-bold text-storm-red uppercase tracking-wide whitespace-nowrap border border-storm-red/40 bg-storm-red/5 hover:bg-storm-red hover:text-white transition-colors rounded-full py-1.5 px-4 group" data-id="element-339">
      <span className="w-1.5 h-1.5 rounded-full bg-storm-red animate-pulse shrink-0 [.group:hover_&]:bg-white" data-id="element-340" />
      Summer Camp
    </Link>;
}